import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

  @Output() filesDropped = new EventEmitter<File[]>();

  // Aceptar el valor para el atributo 'accept'
  @Input() accept: string = '';

  public onFilesDropped(files: File[]) {
    this.filesDropped.emit(files);
  }

  public onFilesHovered(isHovered: boolean) {
    // Puedes usar esta función para cambiar estilos si es necesario
  }

  public onFileInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      this.onFilesDropped(files);
    }
  }
}
